import { DateTime } from "luxon";

export type CareNote = {
  id: string;
  createdAt: string | null;
  note: string;
  author: {
    id: string;
    firstName: string | null;
    lastName: string | null;
  } | null;
  careRecipient: {
    id: string;
    firstName: string | null;
    lastName: string | null;
  } | null;
};

/**
 * Groups notes by their creation time in HH:mm format
 * @param notes Array of CareNote objects
 * @returns Object with time keys (HH:mm) and arrays of notes as values
 */
export function groupNotesByTime(notes: CareNote[]): {
  [time: string]: CareNote[];
} {
  return notes.reduce<{ [time: string]: CareNote[] }>((acc, note) => {
    const time = DateTime.fromISO(note.createdAt ?? "").toFormat("HH:mm");
    if (!acc[time]) acc[time] = [];
    acc[time].push(note);
    return acc;
  }, {});
}
